import * as actionTypes from '@actions/actionTypes';
import {MODAL_TYPE_CONFIRMATION, MODAL_TYPE_ERROR} from '@constants/modals';

export const initialState = {
    isVisible: false,
    component: false,
    content: null,
    header: '',
    size: 'tiny',
    text: '',
    className: null,
    hideButtons: false,
    inProgress: false,
    loading: false,
    onClose: null,
    onYes: null,
    onNo: null,
    type: null,
};

/**
 * Common method for return updated state for:
 * -setModal()
 * -setModalConfirmation()
 */
const setStateModal = (state, modalData) => {
    return {
        ...state,
        ...modalData,
    };
};

/**
 * Set default params if not passed by action:
 * - hideButtons = false (we can display buttons Yes/No only if content not exist - only for confirm dialog)
 * - inProgress = false (for disable buttons in Yes/No modal)
 * - loading = false (for loading status on Yes button in Yes/No modal)
 */
const setNotPassedParams = (data = {}) => {
    const modalData = {...data};

    if (undefined === modalData.hideButtons) {
        modalData.hideButtons = false;
    }

    if (undefined === modalData.inProgress) {
        modalData.inProgress = false;
    }

    if (undefined === modalData.loading) {
        modalData.loading = false;
    }

    return modalData;
};

const modalReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_MODAL : {
            return setStateModal(state, setNotPassedParams(action.data));
        }

        /**
         * setModalConfirmation for modal with Yes/No buttons (confirm modal)
         */
        case actionTypes.SET_MODAL_CONFIRMATION : {
            const modalData = setNotPassedParams(action.data);

            return setStateModal(state, {
                ...modalData,
                type: MODAL_TYPE_CONFIRMATION,
                isVisible: undefined === action.data?.isVisible ? true : modalData.isVisible,
                content: null,
            });
        }

        case actionTypes.SET_MODAL_ERROR : {
            return setStateModal(state, {
                ...setNotPassedParams(action.data),
                type: MODAL_TYPE_ERROR,
            });
        }

        default:
            return state;
    }
};

export default modalReducer;
